<mat-drawer-container class="countable-drawer">

  <mat-drawer-content class="overflow-hidden">
    <div class="page-wraper bg-gray-50 overflow-auto">
      <!-- <div class="fs-notes-container w-100" > -->
      <div class="page-title-block workbook-title-block align-items-start">
        <div class="left-content title-block-left button-group flex-row header-actions">
          <button mat-button mat-stroked-button color="dark" class="btn-medium-icon"
            title="{{isFSNotesExpanded ? 'Collapse' :'Expand'}} All" (click)="expandCollapseNotes(isFSNotesExpanded)">
            <i class="fa-regular fs-3 text-primary-darker" [ngClass]="isFSNotesExpanded ? 'fa-arrow-down-left-and-arrow-up-right-to-center' :'fa-arrow-up-right-and-arrow-down-left-from-center'"></i>
          </button>
          <button mat-button mat-stroked-button color="dark" class="btn-medium-icon" title="Refresh"
            (click)="refreshNotes()">
            <i class="fa-regular fa-arrows-rotate tbh-act-ico"></i>
          </button>
        </div>
        <div class="title-block-middle flexbox-column gap-0 flex-1 align-items-center">
          <h3 class="title text-center">{{clientName}} </h3>
          <h3 class="title text-center">{{headerNotesColumn1}} </h3>
          <ng-container *ngIf="!isSecondColumnClicked">
            <h6 class="title hover-action d-flex flex-row align-items-center gap-8 text-center" [ngClass]="{'ps-3': shortCutMenuDetails.isenglock == 0}" style="min-height:36px;">
              <span [ngClass]="{'ps-2': shortCutMenuDetails.isenglock == 0}">{{headerNotesColumn2}} {{engagementYearEnd | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}</span>
              <ng-container>
                <button mat-button *ngIf="shortCutMenuDetails.isenglock == 0"
                  class="button-medium-icon hover-action-item"
                  (click)="isSecondColumnClicked = true; isThirdColumnClicked = false; isOldSecondColumn = headerNotesColumn2">
                  <i class="fa-regular fa-pen fs-15"></i>
                </button>
              </ng-container>
            </h6>
          </ng-container>
          <ng-container *ngIf="isSecondColumnClicked">
            <mat-form-field class="fixed-label icon-form-after action-2 form-field-medium" style="width: 300px">
              <input matInput [(ngModel)]="headerNotesColumn2" type="text" #focusInputField
                (click)="$event.stopPropagation();">
              <div matSuffix class="actions border-start">
                <button title="save" mat-button color="success" (click)="saveHeaderNote()">
                  <i class="fa-regular fa-check"></i>
                </button>
                <button title="cancel" mat-button color="cancel"
                  (click)="isSecondColumnClicked = false; headerNotesColumn2 = isOldSecondColumn">
                  <i class="fa-regular fa-xmark clear-icon"></i>
                </button>
              </div>
            </mat-form-field>
            <h6 class="title">{{engagementYearEnd | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}</h6>
          </ng-container>
        </div>
        <div class="title-block-right d-none d-lg-flex"></div>
      </div>

        <mat-accordion>
            <mat-expansion-panel class="plan-expansion body-expansion" expanded="true">
                <mat-expansion-panel-header class="d-block d-lg-none filter-actions-button">
                    <mat-panel-title>
                            <div class="plan-expansion-header">
                                <button mat-button mat-stroked-button color="dark" class="button-default">
                                    <span class="flexbox-row gap-8 flex-nowrap">
                                        <span class="title">Actions</span>
                                        <span class="toggle-icon dot-16 bg-transparent"></span>
                                    </span>
                                </button>
                            </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="plan-expansion-body">
                    <div class="sorting-block d-flex flex-row align-items-end justify-content-between p-24 flex-wrap gap-20">
                        <div class="sorting-block-left d-flex flex-row align-items-center gap-8">
                          <mat-checkbox class="mt-1" [checked]="isSelectAll" *ngIf="middleNotes && middleNotes.length > 0" [(ngModel)]="isSelectAll"
                            (change)="selectAll($event)" id="isSelectAll" name="selectAll"><span>Select all</span></mat-checkbox>

                          <button mat-button mat-stroked-button color="dark" [disabled]="!isdelete" class="button-default"
                            *ngIf="shortCutMenuDetails.isenglock === 0"
                            (click)="deleteAll=true;openDeleteDialog('Deleting all selected notes. \n Would you like to proceed?','multiple')">
                            <span class="flexbox-row gap-8">
                              <i class="fa-regular fa-trash-can"></i>
                              <span class="button-label">Delete</span>
                            </span>
                        </button>
                        </div>

                        <div class="sorting-block-right d-flex flex-row gap-8">
                            <mat-form-field floatLabel="always" class="fixed-label label-none flex-1 icon-form-before">
                                <mat-label>Search</mat-label>
                                <input matInput placeholder="Search" [ngModelOptions]="{standalone: true}" #searchField
                                [(ngModel)]="searchMdText" (keyup)="handleMdSearch($event.target.value)" autocomplete="off"
                                maxlength="25">
                                <span matPrefix>
                                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                                </span>
                            </mat-form-field>

                            <button [disabled]="shortCutMenuDetails.isenglock !==0" mat-flat-button mat-button class="button-default"
                                color="primary" [matMenuTriggerFor]="addNotesMenu">
                                <span class="flexbox-row gap-8">
                                <span button-label>Add notes</span>
                                <i class="fa-regular fa-angle-down"></i>
                                </span>
                            </button>
                            <mat-menu #addNotesMenu="matMenu" class="add-notes-menu" xPosition="before">
                                <button mat-menu-item (click)="notesFSImportSelectionDialogFunc(0)">From Firm template</button>
                                <button mat-menu-item (click)="notesFSImportSelectionDialogFunc(1)">From Master library</button>
                                <button mat-menu-item (click)="openCreateCategoryDialog()">Create new category</button>
                            </mat-menu>
                        </div>
                      </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>


        <div class="fs-notes-container-body content-block-main">
            <div class="template-block-main w-100 card h-auto spinner-space" appSpin [spinnerConfig]='spinnerConfig()'>
                <div class="scrool-down-bar-right-side template-block-main w-100 card h-auto"
                     cdkDropListGroup cdkScrollable>
                    @if (middleNotes && middleNotes.length > 0) {
                        <mat-accordion #todoList="cdkDropList" cdkDropList [cdkDropListData]="middleNotes"
                                       (cdkDropListDropped)="drop($event, 1)" class="w-100" multi="true"
                                       [cdkDragDisabled]="shortCutMenuDetails.isenglock === 1"
                                       [cdkDropListDisabled]="shortCutMenuDetails.isenglock === 1">
                            <!--Catergory-->
                            <ng-container
                                    *ngFor="let category of middleNotes; trackBy: trackByCategoryNotes;let i=index">
                                <mat-expansion-panel (keydown.Space)="$event.stopImmediatePropagation();"
                                                     *ngIf="category.notes"
                                                     (opened)="openNotesSection(category)"
                                                     (closed)="closeNotesSection(category)"
                                                     [expanded]="category.isExpand">
                                    <mat-expansion-panel-header class="border-top" cdkDrag
                                                                (keydown.Space)="$event.stopImmediatePropagation();">
                                        <mat-panel-title>
                                            <div class="title-content hover-action"
                                                 [ngClass]="{'search-highlight': category?.highlight}">
                                                <ng-container *ngIf="!category.isEdit">
                        <span class="dragable-icon hover-action-item">
                            <i class="fa-solid fa-grip-dots-vertical"></i>
                        </span>
                                                    <span class="item-checkbox" (click)="$event.stopPropagation();">
                          <mat-checkbox class="label-none" (change)="is_recordChecked(i,'category')"
                                        [checked]="category.is_checked"
                                        (click)="$event.stopPropagation()"></mat-checkbox>
                        </span>
                                                    <span class="togglable-icon">
                            <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                        </span>
                                                    <span class="item-title"
                                                          title="{{category.name}}">{{ category.engNoteId }}
                                                        .{{ category.name }}</span>
                                                    <button *ngIf="shortCutMenuDetails.isenglock ===0" mat-button
                                                            class="button-text hover-action-item"
                                                            (click)="$event.stopPropagation();renameObject(i,'category')">
                                                        <i class="fa-regular fa-pen fs-15"></i>
                                                    </button>

                                                    <button mat-button class="button-text hover-action-item"
                                                            *ngIf="shortCutMenuDetails.isenglock === 0"
                                                            [matMenuTriggerFor]="addNewCategNotesMenu">
                                                        <i class="fa-solid fa-plus"></i>
                                                    </button>
                                                    <mat-menu #addNewCategNotesMenu="matMenu" class="add-notes-menu"
                                                              xPosition="before">
                                                        <button mat-menu-item
                                                                (click)="notesFSImportSelectionDialogFunc(0, true, i)">
                                                            From
                                                            Firm
                                                            template
                                                        </button>
                                                        <button mat-menu-item
                                                                (click)="notesFSImportSelectionDialogFunc(1, true, i)">
                                                            From
                                                            Master
                                                            library
                                                        </button>
                                                        <button mat-menu-item
                                                                (click)="openCreateNotesToFsDialog(category)">
                                                            Create empty note
                                                        </button>
                                                    </mat-menu>

                                                    <button mat-button class="button-text hover-action-item"
                                                            *ngIf="shortCutMenuDetails.isenglock === 0"
                                                            (click)="isCategoryDelete=true;category.isDelete=true;openDeleteDialog('Deleting category ['+category.engNoteId+'] will delete all the notes inside the category. \n Would you like to proceed?','category');$event.stopPropagation()">
                                                        <i class="fa-regular fa-trash-can"></i>
                                                    </button>
                                                </ng-container>

                                                <ng-container *ngIf="category.isEdit">
                                                    <mat-form-field
                                                            class="fixed-label form-field-medium icon-form-after action-2 w-100"
                                                            floatLabel="always">
                                                        <input matInput
                                                               (keydown.Space)="$event.stopImmediatePropagation();"
                                                               (click)="$event.stopPropagation()"
                                                               [(ngModel)]="category.name" autofocus>
                                                        <div matSuffix class="actions border-start">
                                                            <button mat-button color="success" title="save"
                                                                    (click)="saveName(i,j);$event.stopPropagation()"><i
                                                                    class="fa-regular fa-check"></i></button>
                                                            <button mat-button color="cancel" title="Cancel"
                                                                    (click)="cancelRename(i,'category');$event.stopPropagation()">
                                                                <i class="fa-regular fa-xmark clear-icon"></i></button>
                                                        </div>
                                                    </mat-form-field>
                                                </ng-container>
                                            </div>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <!--note template in main template-->
                                    <ng-template matExpansionPanelContent>

                                        <mat-accordion #doneList="cdkDropList" cdkDropList
                                                       [cdkDropListData]="category.notes || middleNotes"
                                                       (cdkDropListDropped)="drop($event, 2)"
                                                       (mouseover)="$event.stopPropagation();" multi="true">
                                            <ng-container
                                                    *ngFor="let eData of category.notes; trackBy: trackBySubCategoryNotes let j=index">

                                                <mat-expansion-panel
                                                        (keydown.Space)="$event.stopImmediatePropagation();"
                                                        hideToggle
                                                        (opened)="openNotesSection(eData)"
                                                        (closed)="closeNotesSection(eData)"
                                                        [expanded]="eData.isExpand">
                                                    <mat-expansion-panel-header cdkDrag
                                                                                (keydown.Space)="$event.stopImmediatePropagation();">
                                                        <mat-panel-title>
                                                            <div class="title-content hover-action"
                                                                 [ngClass]="{'search-highlight': eData?.highlight}">
                                                                <ng-container *ngIf="!eData.isEdit">
                                <span class="dragable-icon hover-action-item">
                                    <i class="fa-solid fa-grip-dots-vertical"></i>
                                </span>
                                                                    <span class="item-checkbox"
                                                                          (click)="$event.stopPropagation();">
                                  <mat-checkbox class="label-none" (change)="is_recordChecked(i,'subcategory',j)"
                                                [checked]="eData.is_checked"
                                                (click)="$event.stopPropagation()"></mat-checkbox>
                                </span>
                                                                    <span class="togglable-icon">
                                    <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                </span>
                                                                    <span class="item-icon">
                                  <img alt="icon" src="/assets/images/icons/notes-icon.svg" />
                                </span>
                                                                    <span class="item-title">
                                  {{eData.engNoteId}}.{{eData.name}}
                                </span>
                                                                    <button mat-button
                                                                            class="button-text hover-action-item"
                                                                            *ngIf="shortCutMenuDetails.isenglock === 0"
                                                                            (click)="$event.stopPropagation();renameObject(i,'categorynotes',j)">
                                                                        <i class="fa-regular fa-pen fs-15"></i>
                                                                    </button>
                                                                    <button mat-button
                                                                            class="button-text hover-action-item"
                                                                            *ngIf="shortCutMenuDetails.isenglock === 0"
                                                                            (click)="isSubCategoryDelete=true;eData.isDelete=true;openDeleteDialog(eData.engNoteId,'note');$event.stopPropagation()">
                                                                        <i class="fa-regular fa-trash-can"></i>
                                                                    </button>
                                                                </ng-container>
                                                                <ng-container *ngIf="eData.isEdit">
                                                                    <mat-form-field
                                                                            class="fixed-label label-none form-field-medium icon-form-after action-2 w-100"
                                                                            floatLabel="always">
                                                                        <mat-label>Note not in sub category</mat-label>
                                                                        <input (keydown.Space)="$event.stopImmediatePropagation();"
                                                                               (click)="$event.stopPropagation()"
                                                                               matInput
                                                                               placeholder="Note not in sub category"
                                                                               [(ngModel)]="eData.name" autofocus>
                                                                        <div matSuffix class="actions border-start">
                                                                            <button mat-button color="success"
                                                                                    title="save"
                                                                                    (click)="saveName(i,j);$event.stopPropagation()">
                                                                                <i class="fa-regular fa-check"></i>
                                                                            </button>
                                                                            <button mat-button color="cancel"
                                                                                    title="Cancel"
                                                                                    (click)="cancelRename(i,'categorynotes',j);$event.stopPropagation()">
                                                                                <i class="fa-regular fa-xmark clear-icon"></i>
                                                                            </button>
                                                                        </div>
                                                                    </mat-form-field>
                                                                </ng-container>
                                                            </div>
                                                        </mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <!-- <app-fs-editor *ngIf="eData.isEditorOpen" [isReadOnly]="false" [htmlContent]="eData.content" [hideButtons]="false" (onClickCancel)="eData.isEditorOpen = $event;"  (onClickSave) = "updateEditorContent($event, eData, i, 'subCategory')"></app-fs-editor> -->
                                                    <ng-template matExpansionPanelContent>
                                                        <div class="align-items-center d-flex flex-column gap-20 flex-nowrap  w-100">
                                                            <div class="gap-8 flex-column d-flex w-100"
                                                                 style="padding: 10px 3vw; max-height: 55vh; overflow: auto;">
                                                                <div class="notes-container"
                                                                     *ngFor="let section of eData.sectionsArray; trackBy: section; let ind = index"
                                                                     class="align-items-center d-flex flex-row flex-nowrap gap-8 w-100">
                                                                    <div *ngIf="saveEnabled(eData?.items, eData?.originalItems) || justEditChanged(eData?.items, eData?.originalItems)"
                                                                         class="flexbox-column w-auto flex-nowrap align-items-center justify-content-center">
                                                                        <button mat-button mat-stroked-button
                                                                                class="button-default-icon" color="dark"
                                                                                (click)="moveUp(eData, ind)"
                                                                                title="Move Up"
                                                                                *ngIf="ind !== 0">
                                                                            <i class="fa-regular fs-20 fa-up-long"></i>
                                                                        </button>
                                                                        <button mat-button mat-stroked-button
                                                                                class="button-default-icon" color="dark"
                                                                                (click)="moveDown(eData, ind)"
                                                                                title="Move Down"
                                                                                *ngIf="ind !== eData.sectionsArray.length-1">
                                                                            <i class="fa-regular fs-20 fa-down-long"></i>
                                                                        </button>
                                                                    </div>
                                                                    <div class="w-100 overflow-auto">
                                                                        <!-- Text Section -->
                                                                        <div class="datahtml card  w-100"
                                                                             *ngIf="eData.items[ind].type === 'text'">
                                                                            <app-custom-editor *ngIf="eData.isExpand"
                                                                                               [isInsideWorkbook]="true"
                                                                                               [htmlContent]="eData.items[ind]"
                                                                                               (emitEveryChange)="updateTextEditorData($event, ind, eData);"
                                                                                               [showDelete]="shortCutMenuDetails.isenglock === 0?true:false"
                                                                                               (deleteSection)="deleteSection(eData,ind)"
                                                                                               [isViewMode]="eData.items[ind].isEdit"
                                                                                               (updateTextEdit)="updateEditProperty($event,eData,ind, j)"
                                                                                               class="card-body"></app-custom-editor>
                                                                        </div>

                                                                        <!-- Table Section-->
                                                                        <div class="datahtml w-100 "
                                                                             *ngIf="eData.items[ind].type === 'table'">

                                                                            <app-fs-table
                                                                                    [htmlContent]="eData.items[ind]"
                                                                                    (updateTableData)="updateTableData($event, ind, eData, i)"
                                                                                    (deleteSection)="deleteSection(eData,ind)"
                                                                                    [isViewMode]="eData.items[ind].isEdit"
                                                                                    (updateTableEdit)="updateEditProperty($event,eData,ind, j)"
                                                                                    [isAutomated]="eData.isAutomated"></app-fs-table>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div *ngIf="eData.items.length === 0 && !eData.isAutomated"
                                                                     [ngClass]="{'no-data-found w-100 h-100 align-items-center justify-content-center d-flex flex-column flex-nowrap' :eData.items.length === 0 }"
                                                                     class="gap-8">
                                                                    <ng-container
                                                                            *ngIf="shortCutMenuDetails.isenglock === 0">
                                                                        <img
                                                                                src="../../../../../assets/images/ui-uplift-icons/global/empty-component-icon.svg"
                                                                                alt="Countable"><br>
                                                                        <p><b>Add your notes here</b></p>
                                                                        <p> Click the <b>+ Add Type</b> to add your
                                                                            notes
                                                                        </p>
                                                                    </ng-container>
                                                                    <button mat-button mat-flat-button color="primary"
                                                                            class="button-default"
                                                                            [matMenuTriggerFor]="addType">
                                  <span class="flexbox-row gap-8">
                                    <i class="fa-solid fa-plus"></i>
                                    <span class="button-label">Add Type</span>
                                  </span>
                                                                    </button>
                                                                    <mat-menu #addType="matMenu" xPosition="before"
                                                                              class="foldermenu"
                                                                              style="min-width: 124px;">
                                                                        <button mat-menu-item title="Add table section"
                                                                                class="add-row-btn"
                                                                                (click)="addSection('table', eData)">
                                                                            <span>Table</span>
                                                                        </button>
                                                                        <button mat-menu-item title="Add text section"
                                                                                class="add-row-btn"
                                                                                (click)="addSection('text', eData)">
                                                                            <span> Text</span>
                                                                        </button>
                                                                    </mat-menu>
                                                                </div>

                                                                <div
                                                                        *ngIf="eData.items.length !== 0 && shortCutMenuDetails.isenglock === 0  && !eData.isAutomated"
                                                                        class="d-flex button-group justify-content-start w-100">
                                                                    <button mat-button mat-flat-button color="primary"
                                                                            [ngClass]="{' ms-5' :eData.items.length > 1 && (saveEnabled(eData?.items, eData?.originalItems) || justEditChanged(eData?.items, eData?.originalItems))}"
                                                                            [matMenuTriggerFor]="addType"
                                                                            class="me-auto button-default">
                                  <span class="flexbox-row gap-8">
                                    <i class="fa-solid fa-plus"></i>
                                    <span class="button-label">Add Type</span>
                                  </span>
                                                                    </button>
                                                                    <mat-menu #addType="matMenu" xPosition="before"
                                                                              class="foldermenu"
                                                                              style="min-width: 124px;">
                                                                        <button mat-menu-item title="Add table section"
                                                                                class="add-row-btn"
                                                                                (click)="addSection('table', eData)">
                                                                            <span>Table</span>
                                                                        </button>
                                                                        <button mat-menu-item title="Add text section"
                                                                                class="add-row-btn"
                                                                                (click)="addSection('text', eData)">
                                                                            <span> Text</span>
                                                                        </button>
                                                                    </mat-menu>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex button-group justify-content-end w-100"
                                                                 style="padding-right: 100px;  padding-bottom: 10px;">
                                                                <button mat-button mat-stroked-button
                                                                        *ngIf="(saveEnabled(eData?.items, eData?.originalItems) || justEditChanged(eData?.items, eData?.originalItems))"
                                                                        color="dark"
                                                                        [disabled]="shortCutMenuDetails.isenglock !== 0"
                                                                        class="button-default"
                                                                        (click)="cancelSaveNotes(eData)">Cancel
                                                                </button>
                                                                <button mat-button mat-flat-button color="primary"
                                                                        class="button-default"
                                                                        *ngIf="(saveEnabled(eData?.items, eData?.originalItems) || justEditChanged(eData?.items, eData?.originalItems))"
                                                                        [disabled]="shortCutMenuDetails.isenglock !== 0"
                                                                        (click)="saveLatestDataFromFsTable('update')">
                                                                    Save
                                                                    Changes
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </ng-template>

                                                </mat-expansion-panel>
                                            </ng-container>
                                        </mat-accordion>

                                    </ng-template>

                                </mat-expansion-panel>

                                <mat-expansion-panel (keydown.Space)="$event.stopImmediatePropagation();" hideToggle
                                                     *ngIf="!category.notes" (opened)="openNotesSection(category)"
                                                     (closed)="closeNotesSection(category)"
                                                     [expanded]="category.isExpand"
                                                     [ngClass]="{'mat-expanded': category.isExpand}">
                                    <mat-expansion-panel-header class="border-top" cdkDrag
                                                                (keydown.Space)="$event.stopImmediatePropagation();">
                                        <mat-panel-title>
                                            <div class="title-content hover-action"
                                                 [ngClass]="{'search-highlight': category?.highlight}">
                                                <ng-container *ngIf="!category.isEdit">
                        <span class="dragable-icon hover-action-item">
                            <i class="fa-solid fa-grip-dots-vertical"></i>
                        </span>
                                                    <span class="item-checkbox" (click)="$event.stopPropagation();">
                          <mat-checkbox class="label-none" (change)="is_recordChecked(i,'category')"
                                        [checked]="category.is_checked"
                                        (click)="$event.stopPropagation()"></mat-checkbox>
                        </span>
                                                    <span class="togglable-icon">
                            <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                        </span>
                                                    <span class="item-icon">
                          <img alt="icon" src="/assets/images/icons/notes-icon.svg" />
                        </span>
                                                    <span class="item-title">
                          {{category.engNoteId}}.{{category.name}}
                        </span>
                                                    <button mat-button class="button-text hover-action-item"
                                                            *ngIf="shortCutMenuDetails.isenglock === 0"
                                                            (click)="$event.stopPropagation();renameObject(i,'category')">
                                                        <i class="fa-regular fa-pen fs-15"></i>
                                                    </button>
                                                    <button mat-button class="button-text hover-action-item"
                                                            *ngIf="shortCutMenuDetails.isenglock === 0"
                                                            (click)="isCategoryDelete=true;category.isDelete=true; openDeleteDialog(category.engNoteId,'note');$event.stopPropagation()">
                                                        <i class="fa-regular fa-trash-can"></i>
                                                    </button>
                                                </ng-container>

                                                <ng-container *ngIf="category.isEdit">
                                                    <mat-form-field
                                                            class="fixed-label label-none form-field-medium icon-form-after input-fields-item action-2 w-100">
                                                        <mat-label>Value</mat-label>
                                                        <input matInput
                                                               (keydown.Space)="$event.stopImmediatePropagation();"
                                                               (click)="$event.stopPropagation()"
                                                               [(ngModel)]="category.name" autofocus>
                                                        <div matSuffix class="actions border-start">
                                                            <button mat-button color="success" title="save"
                                                                    (click)="saveName(i);$event.stopPropagation()"><i
                                                                    class="fa-regular fa-check"></i></button>
                                                            <button mat-button color="cancel" title="Cancel"
                                                                    (click)="cancelRename(i,'category');$event.stopPropagation()">
                                                                <i class="fa-regular fa-xmark clear-icon"></i></button>
                                                        </div>
                                                    </mat-form-field>
                                                </ng-container>
                                            </div>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>

                                        <div class="align-items-center d-flex flex-column gap-20 flex-nowrap  w-100 pe-3">
                                            <div class=" gap-8 flex-column d-flex w-100"
                                                 style="padding:10px 15px;max-height:50vh;overflow:auto;max-width:1400px;">
                                                <div class="notes-container "
                                                     *ngFor="let section of category.sectionsArray; trackBy: section; let mainSectionIndex = index"
                                                     class="align-items-center d-flex flex-row flex-nowrap gap-8 w-100">
                                                    <div
                                                            *ngIf="saveEnabled(category?.items, category?.originalItems) || justEditChanged(category?.items, category?.originalItems)"
                                                            class="flexbox-column w-auto flex-nowrap align-items-center justify-content-center">
                                                        <button mat-button mat-stroked-button class="button-default-icon"
                                                                color="dark" (click)="moveUp(category,mainSectionIndex)"
                                                                title="Move Up" *ngIf="mainSectionIndex !== 0">
                                                            <i class="fa-regular fs-20 fa-up-long"></i>
                                                        </button>
                                                        <button mat-button mat-stroked-button class="button-default-icon"
                                                                color="dark"
                                                                (click)="moveDown(category,mainSectionIndex)"
                                                                title="Move Down"
                                                                *ngIf="mainSectionIndex !== category.sectionsArray.length-1">
                                                            <i class="fa-regular fs-20 fa-down-long"></i>
                                                        </button>
                                                    </div>
                                                    <div class="w-100 overflow-auto">
                                                        <!-- Text Section -->
                                                        <div class="datahtml card  w-100"
                                                             *ngIf="category.items[mainSectionIndex].type === 'text'"
                                                             style="min-height: 40px;">
                                                            <app-custom-editor *ngIf="category.isExpand"
                                                                               [isInsideWorkbook]="true"
                                                                               [htmlContent]="category.items[mainSectionIndex]"
                                                                               (emitEveryChange)="updateTextEditorData($event, mainSectionIndex, category);"
                                                                               [showDelete]="shortCutMenuDetails.isenglock === 0?true:false"
                                                                               (deleteSection)="deleteSection(category,mainSectionIndex)"
                                                                               [isViewMode]="category.items[mainSectionIndex].isEdit"
                                                                               (updateTextEdit)="updateEditProperty($event, category, mainSectionIndex, i)"
                                                                               class="card-body"></app-custom-editor>
                                                        </div>

                                                        <!-- Table Section-->
                                                        <div class="datahtml w-100 "
                                                             *ngIf="category.items[mainSectionIndex].type === 'table'">

                                                            <app-fs-table
                                                                    [htmlContent]="category.items[mainSectionIndex]"
                                                                    (updateTableData)="updateTableData($event, mainSectionIndex, category, i)"
                                                                    (deleteSection)="deleteSection(category,mainSectionIndex)"
                                                                    [isViewMode]="category.items[mainSectionIndex].isEdit"
                                                                    (updateTableEdit)="updateEditProperty($event, category, mainSectionIndex, i)"
                                                                    [isAutomated]="category.isAutomated"></app-fs-table>


                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                        *ngIf="category?.items?.length && category.items.length === 0 && shortCutMenuDetails.isenglock === 0  && !category.isAutomated"
                                                        [ngClass]="{'no-data-found w-100 h-100 align-items-center justify-content-center d-flex flex-column flex-nowrap' :category.items.length === 0 }"
                                                        class="gap-8">
                                                    <ng-container>
                                                        <img src="../../../../../assets/images/ui-uplift-icons/global/empty-component-icon.svg"
                                                             alt="Countable"><br>
                                                        <p><b>Add your notes here</b></p>
                                                        <p> Click the <b>+ Add Type</b> to add your notes </p>
                                                    </ng-container>
                                                    <button mat-button mat-flat-button color="primary"
                                                            class="button-default"
                                                            [matMenuTriggerFor]="addType">
                          <span class="flexbox-row gap-8">
                            <i class="fa-solid fa-plus"></i>
                            <span class="button-label">Add Type</span>
                          </span>
                                                    </button>
                                                    <mat-menu #addType="matMenu" xPosition="before" class="foldermenu"
                                                              style="min-width: 124px;">
                                                        <button mat-menu-item title="Add table section"
                                                                class="add-row-btn"
                                                                (click)="addSection('table', category)">
                                                            <span>Table</span>
                                                        </button>
                                                        <button mat-menu-item title="Add text section"
                                                                class="add-row-btn"
                                                                (click)="addSection('text', category)">
                                                            <span> Text</span>
                                                        </button>
                                                    </mat-menu>
                                                </div>


                                                <div
                                                        *ngIf="category?.items?.length && category.items.length !== 0 && shortCutMenuDetails.isenglock === 0 && !category.isAutomated"
                                                        class="d-flex button-group justify-content-start w-100">
                                                    <button mat-button mat-flat-button color="primary"
                                                            [ngClass]="{' ms-5' :category.items.length > 1 && (saveEnabled(category?.items, category?.originalItems) || justEditChanged(category?.items, category?.originalItems))}"
                                                            [matMenuTriggerFor]="addType" class="me-auto button-default">
                          <span class="flexbox-row gap-8">
                            <i class="fa-solid fa-plus"></i>
                            <span class="button-label">Add Type</span>
                          </span>
                                                    </button>
                                                    <mat-menu #addType="matMenu" xPosition="before" class="foldermenu"
                                                              style="min-width: 124px;">
                                                        <button mat-menu-item title="Add table section"
                                                                class="add-row-btn"
                                                                (click)="addSection('table', category)">
                                                            <span>Table</span>
                                                        </button>
                                                        <button mat-menu-item title="Add text section"
                                                                class="add-row-btn"
                                                                (click)="addSection('text', category)">
                                                            <span> Text</span>
                                                        </button>
                                                    </mat-menu>
                                                </div>
                                            </div>
                                            <div class="d-flex button-group justify-content-end w-100"
                                                 style="padding:0px 15px 10px;max-width:1400px;">
                                                <button mat-button mat-stroked-button
                                                        *ngIf="(saveEnabled(category?.items, category?.originalItems) || justEditChanged(category?.items, category?.originalItems))"
                                                        color="dark" class="button-default"
                                                        (click)="cancelSaveNotes(category)">Cancel
                                                </button>
                                                <button mat-button mat-flat-button color="primary" class="button-default"
                                                        *ngIf="(saveEnabled(category?.items, category?.originalItems) || justEditChanged(category?.items, category?.originalItems))"
                                                        (click)="saveLatestDataFromFsTable('update')"
                                                        [disabled]="shortCutMenuDetails.isenglock !== 0">Save
                                                    Changes
                                                </button>
                                            </div>


                                        </div>


                                    </ng-template>

                                </mat-expansion-panel>
                            </ng-container>
                        </mat-accordion>
                    }
                </div>

            </div>
      </div>


      <!--empty list-->
        <div class="no-data-found" *ngIf="middleNotes && middleNotes.length == 0 && !spinnerConfig().isSpinShown">
        <img src="/assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
        <h6>No notes added yet</h6>
      </div>
      <!-- </div> -->
    </div>
  </mat-drawer-content>

  <!--preview-->
  <mat-drawer #drawer appResizableDrawer resizeDirection="left" [minWidth]="600" [maxWidth]="700" (resizeEvent)="onResizePanelEnd($event)" style="width: 600px;" class="order-2 drawer-from-right prev-right-drawer">
    <div class="toogle-button-block button-block-right">
      <button mat-button class="button-medium-icon toogle-button" (click)="drawer.toggle()"></button>
      <div class="toogle-content">
        <h6 class="title">Preview</h6>
      </div>
    </div>
    <div class="content-block notes-container-aside">
      <div class="notes-container-aside-body h-100">
        <notes-to-fs-preview class="h-100 d-block overflow-auto"></notes-to-fs-preview>
      </div>
    </div>
  </mat-drawer>

</mat-drawer-container>

<!--note template -->
<ng-template #notesTemplate>
  <ng-container *ngIf="editorData">
    <mat-expansion-panel (keydown.Space)="$event.stopImmediatePropagation();" hideToggle
      (opened)="eData.isEditorOpen = true" (closed)="eData.isEditorOpen = false" *ngFor="let eData of editorData"
      [expanded]="isNotesExpanded">
      <mat-expansion-panel-header class="editable-header" (keydown.Space)="$event.stopImmediatePropagation();">
        <mat-panel-title class="bg-w">
          <div class="signOff-left1 rename-set co-left-signoff flex-box-left-right">
            <div class="flex-box-col" style="justify-content: none;">
              <div class="drag-drop">
                <span class="transparent-btn drag-btn">
                  <button mat-icon-button class=" drag-btn border-0 w-auto p-0">
                    <i class="fa-solid fa-grip-dots-vertical"></i>
                  </button>
                </span>
              </div>
              <div class="left-label1">
                <mat-checkbox class="" (click)="$event.stopPropagation()">
                    <i class="fa-regular fa-subtitles"></i>
                  <span class="numbering">{{index}}.</span>
                  <span class="noteLabel" *ngIf="!rename">{{eData.name}}</span>
                </mat-checkbox>
                <div class="d-flex flex-row align-items-center" *ngIf="rename">
                  <mat-form-field
                    class="mat-form-item fixed-label form-field-medium icon-form-after input-fields-item action-2 w-100"
                    floatLabel="always">
                    <input class="mat-input-element " matInput (click)="$event.stopPropagation()"
                      matinput="Note not in sub category" value="{{eData.name}}" style="height: 30px;">

                    <span matSuffix class="actions border-start">
                      <button mat-button color="success" title="save"
                        (click)="$event.stopPropagation()"><i class="fa-regular fa-check"></i></button>

                      <button mat-button color="cancel" title="Cancel"
                        (click)="cancelRename();$event.stopPropagation()"><i class="fa-regular fa-xmark clear-icon"></i></button>
                    </span>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="right-side-container  float-right">
              <div class="icon-container editable-header-main">
                <span class="transparent-btn" *ngIf="!rename">
                  <button mat-icon-button *ngIf="shortCutMenuDetails.isenglock === 0"
                    class="button-medium-icon-action button-tooltip edit-label-icon edit"
                    (click)="$event.stopPropagation();renameObject()">
                    <i class="fa-regular fa-pen fs-15"></i>
                  </button>
                </span>
                <span class="transparent-btn">
                  <button *ngIf="shortCutMenuDetails.isenglock === 0" mat-icon-button class="delete delete-temp-btn">
                    <i class="fa-regular fa-trash-can"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <app-fs-editor *ngIf="eData.isEditorOpen" [isReadOnly]="false" [(ngModel)]="eData.content"
          [htmlContent]="eData.content">
        </app-fs-editor>
      </div>
      <div class="fullrow float-right mar-tb-16" style="padding-right: 100px; padding-bottom: 10px;">
        <button class="mat-stroked-button mar-r-16 " (click)="eData.isEditorOpen = false"
          [disabled]="shortCutMenuDetails.isenglock !== 0">
          Cancel
        </button>
        <button mat-flat-button class="mar-r-16 blue-1-button" (click)="updateEditorContent(eData.content)"
          [disabled]="shortCutMenuDetails.isenglock !== 0">
          Save changes
        </button>
      </div>
    </mat-expansion-panel>
  </ng-container>
</ng-template>

<!--dialog layout-->
<ng-template #notesFSImportSelectionDialog>
  <div class="notesFSImport countable-dialog template-block-main right-drawer" style="width: 350px; max-height: 100vh;">

    <div mat-dialog-title class="dialog-header py-8 ">
      <h4 class="title">Add notes </h4>
      <button mat-button class="close" aria-label="Close" mat-dialog-close type="button">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>


    <div class=" dialog-body-content px-0">
        <mat-tab-group class="" [selectedIndex]="notesSRC ? notesSRC : null" (selectedIndexChange)="onChangeFrom($event)">
            <mat-tab>
            <ng-template mat-tab-label>
                <span>Firm templates</span>
            </ng-template>
            <ng-container *ngTemplateOutlet="linkNotes"></ng-container>
            </mat-tab>
            <mat-tab>
            <ng-template mat-tab-label>
                <span>Master Library</span>
            </ng-template>
            @if(!isPegPactExpired()){
              <ng-container *ngTemplateOutlet="pegPactExpired"></ng-container>
            } @else{
              <ng-container *ngTemplateOutlet="linkNotes"></ng-container>
            }

            </mat-tab>
        </mat-tab-group>

        <div class=" d-none">
            <mat-select [(ngModel)]="notesSRC" [items]="importOptions" bindLabel="value" bindValue="id" [disabled]="id == 0"
            [clearable]="false" (change)="onChangeFrom($event)"
            class="typo-head-dropdown1 team-dropdown type-ent entity-field" maxlength="100">
            </mat-select>
        </div>

        <ng-template #linkNotes>
            <div class="search-block gap-20">
            <mat-form-field floatLabel="always" class="fixed-label label-none w-100 flex-1 icon-form-before">
                <mat-label>Search</mat-label>
                <input matInput maxlength="35" #searchField [(ngModel)]="searchText"
                (keyup)="handleSearch($event.target.value)" placeholder="Search" autocomplete="off">
                <span matPrefix>
                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                </span>
            </mat-form-field>
            <button mat-button mat-stroked-button color="primary" class="btn-medium-icon" title="Expand All"
                (click)="addNotesExpandAll=!addNotesExpandAll" *ngIf="!addNotesExpandAll">
                <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center fs-3 text-primary"></i>
            </button>
            <button mat-button mat-stroked-button color="primary" class="btn-medium-icon" title="Collapse All"
                (click)="addNotesExpandAll=!addNotesExpandAll" *ngIf="addNotesExpandAll">
                <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center fs-3 text-primary"></i>
            </button>
            </div>

            <mat-checkbox [(ngModel)]="allNotesCheked" [checked]="allNotesCheked" (change)="multiCheck()" class="ps-20">
            <span>Select all</span>
            </mat-checkbox>
            <div class="templates-list">

            <mat-accordion class="" multi="true" [togglePosition]="'before'" class="w-100">
                <ng-container *ngFor="let category of notes; let i=index; trackBy: trackByRecords;">
                <ng-container>
                    <mat-expansion-panel [expanded]="category.isExpand || addNotesExpandAll " class="level-one">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                        <div class="title-content"
                            [ngClass]="{'active': category.isCheckedCategory,'search-highlight': category?.highlight}">
                            <span class="togglable-icon">
                                <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                            </span>
                            <mat-checkbox [(ngModel)]="category.isCheckedCategory" (click)="$event.stopPropagation()"
                            (change)="singleCheck('category', category.isCheckedCategory, category)"
                            class="item-checkbox"> </mat-checkbox>
                            <span class="item-icon">
                              <i class="fa-solid fa-folder-open text-primary"></i>
                            </span>
                            <span class="ellipse item-title" title="{{category.name}}"> {{category.name}}</span>
                        </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <ng-container *ngFor="let subCategory of category.subcategories">
                        <mat-expansion-panel [expanded]="subCategory.isExpand || addNotesExpandAll" class="level-two">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                            <div class="title-content"
                                [ngClass]="{'active': subCategory.isSubcategoryChecked,'search-highlight': subCategory?.highlight}">
                                <span class="togglable-icon">
                                    <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                </span>
                                <mat-checkbox [(ngModel)]="subCategory.isSubcategoryChecked"
                                (click)="$event.stopPropagation()" class="item-checkbox"
                                (change)="singleCheck('subCategory', subCategory.isSubcategoryChecked, subCategory, category)">
                                </mat-checkbox>
                                <span class="item-icon">
                                  <i class="fa-solid fa-folder-open text-primary"></i></span>
                                <span class="item-title" title="{{subCategory.name}}">{{subCategory.name}}</span>
                            </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="templates-list-items">
                            <li class="list-item-content" title="{{note.name}}"
                            [ngClass]="{'active': note.isNotesChecked,'search-highlight': note?.highlight}"
                            *ngFor="let note of subCategory.notes">
                            <span class="item-checkbox">
                                <mat-checkbox class="label-none" [(ngModel)]="note.isNotesChecked"
                                (change)="singleCheck('subCategoryNotes', note.isNotesChecked, subCategory, category)"></mat-checkbox>
                            </span>
                            <span class="item-icon">
                                <img src="/assets/images/icons/notes-icon.svg" alt="Toogle">
                            </span>
                            <span class="item-title">
                                {{note.name}}
                            </span>
                            </li>
                        </ul>
                        </mat-expansion-panel>
                    </ng-container>

                    <ul class="templates-list-items">
                        <li class="list-item-content" title="{{note.name}}" *ngFor="let note of category.notes"
                        [ngClass]="{'checked': note.isNotesChecked,'search-highlight': note?.highlight}">
                        <span class="item-checkbox">
                            <mat-checkbox class="label-none" [(ngModel)]="note.isNotesChecked"
                            (change)="singleCheck('categoryNotes', note.isNotesChecked, category)">
                            </mat-checkbox>
                        </span>
                        <span class="item-icon">
                            <img src="../../../../../assets/images/icons/notes-icon.svg" alt="Toogle">
                        </span>
                        <span class="item-title">
                            {{note.name}}
                        </span>
                        </li>
                    </ul>
                    </mat-expansion-panel>
                </ng-container>

                </ng-container>
            </mat-accordion>
            </div>
            <div class="mat-dialog-actions w-100 ">
              <div class="dialog-footer d-flex  flex-row flex-nowrap align-items-center justify-content-end ">
                <button mat-button mat-flat-button color="primary" class="button-default" [mat-dialog-close]
                  [disabled]="notesCount == 0" style="flex: none;" (click)="addNotes()">Add notes {{notesCount > 0 ?
                  '('+notesCount+')':''}}</button>
              </div>
            </div>
        </ng-template>
        <ng-template #pegPactExpired>
          <div class="no-data-found">
            <img src="/assets/images/ui-uplift-icons/global/empty-component-icon.png" alt="Icon">
            <button [disabled]="true" class="text-link">Update PEG/PACT license information</button>
            <p>for access to the Master library letters, checklists, notes to financial statements and reports</p>
        </div>
        </ng-template>
        </div>
  </div>
</ng-template>

<!--delete dialog-->
<ng-template #deleteDialog>
  <div class="countable-dialog confirmation-dailog" style="width: 400px;">
    <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-trash-can text-error"></i>
      </span>
      <h4 class="title text-center">Delete {{dialogboxHeader}}</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
      <p class="font-fam" *ngIf="deletableLinkedNotes.length==0">{{dialogboxText}}</p>
      <p class="font-fam" *ngIf="deletableLinkedNotes && deletableLinkedNotes.length">
        {{dialogboxLinkedText}}
      </p>
    </div>

    <div mat-dialog-actions class="dialog-footer button-group w-100" *ngIf="shortCutMenuDetails.isenglock === 0">
      <button mat-button mat-stroked-button class="button-large flex-1" color="dark" [mat-dialog-close]
        (click)="cancelDelete()">
        Cancel
      </button>
      <button mat-button mat-flat-button class="button-large flex-1 m-0" color="error" [mat-dialog-close]
        (click)="deleteAll? deleteSelectedWtihLinkedNotes() : deleteNoteWithLinkedNotes()">
        Delete
      </button>
    </div>
  </div>

</ng-template>
<!--delete dialog-->
<ng-template #createCategoryDialog>
  <div class="create-catergory-dialog countable-dialog mw-400 " style="width: 400px;">
    <div class="dialog-header">
      <div class="border-gray-3 br-4" style="padding: 8px;">
        <i class="fa-regular fa-folder-plus"></i>
      </div>
      <button class="transparent-btn close" aria-label="Close" mat-dialog-close type="button">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div class="dialog-body-content gap-8">
      <h4> Create Category </h4>
      <mat-form-field floatLabel="always" class="fixed-label w-100">
        <mat-label>Category title </mat-label>

        <input matInput="" #searchField [(ngModel)]="CreateCategoryName" placeholder="Enter Category Name"
          autocomplete="off" required>
      </mat-form-field>

    </div>
    <div class="mat-dialog-actions w-100 ">
      <div
        class="dialog-footer d-flex button-group  flex-row flex-nowrap align-items-center justify-content-between w-100">
        <button mat-stroked-button mat-button color="dark" [mat-dialog-close] class="w-100 button-default"
          (click)="CreateCategoryName=''">
          Cancel
        </button>
        <button mat-flat-button mat-button color="primary" [mat-dialog-close] class="w-100 button-default"
          (click)="createNewCategory()">
          Create
        </button>

      </div>
    </div>
  </div>
</ng-template>

<!-- add empty note -->
<ng-template #CreateNotesToFsDialog>
  <div class="countable-dialog notes-template-dialog" style="width: 350px;">
    <div class="dialog-header">
      <div class="border-gray-3 br-4" style="padding: 8px;">
        <i class="fa-regular fa-folder"></i>
        <!-- <img src="../../../../assets/images/ui-uplift-icons/global/{{fsdialogcreateheader==='note'?'sticker-square':'folder'}}.svg"
          alt=""> -->
      </div>
      <button class="transparent-btn close" aria-label="Close" mat-dialog-close type="button">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div class="dialog-body-content gap-8">
      <h5>Create note </h5>
      <mat-form-field floatLabel="always" class="fixed-label w-100">
        <mat-label>Note Title</mat-label>
        <input matInput [(ngModel)]="fsnotesnaming" id="name" placeholder="Enter note title"
          (keypress)="avoidUnderscore($event)" required="" />
      </mat-form-field>
    </div>
    <div class="mat-dialog-actions w-100 ">
      <div
        class="dialog-footer d-flex button-group flex-row flex-nowrap align-items-center justify-content-between w-100">
        <button mat-button mat-stroked-button color="dark" class="w-100 button-default" [mat-dialog-close]>
          Cancel</button>
        <button mat-flat-button mat-button color="primary" class="w-100 button-default" [mat-dialog-close]
          (click)="createfirmtemplatesfsnotes()" [disabled]="fsnotesnaming === ''">
          Create
        </button>
      </div>
    </div>
  </div>
</ng-template>
